import { defineComponent as n, createElementBlock as t, openBlock as s, normalizeProps as i, guardReactiveProps as p, unref as d, renderSlot as u } from "vue";
import { useOUIAProps as f } from "../../helpers/ouia.js";
const P = /* @__PURE__ */ n({
  name: "PfCardHeaderMain",
  __name: "CardHeaderMain",
  props: {
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(o) {
    const e = o, a = f({ id: e.ouiaId, safe: e.ouiaSafe });
    return (r, c) => (s(), t("div", i(p(d(a))), [
      u(r.$slots, "default")
    ], 16));
  }
});
export {
  P as default
};
